module.exports = __webpack_public_path__ + "media/images/app/colors/colors-silver-d3362d491230250bea1a14d8f7f1f8db.webp";